import React, { useEffect } from 'react';

// Redirects the SPA route "/blog" to the static, canonical "/blog/"
const BlogIndexRedirect = () => {
  useEffect(() => {
    // Ensure search engines and users land on the static blog index
    window.location.replace('/blog/');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="spinner spinner-lg mx-auto mb-4"></div>
        <p className="text-gray-700 font-jetbrains">Loading blog…</p>
        <p className="text-gray-500 text-sm mt-2">
          If you are not redirected, <a className="underline" href="/blog/">click here</a>.
        </p>
      </div>
    </div>
  );
};

export default BlogIndexRedirect;

